// Layout — page content wrapper.
//
// Now that the app shell (Sidebar + Header + ⌘K palette + mobile menu) lives
// at the router level in `<Shell />` and stays mounted across navigation,
// this component's only job is to give each page its consistent `<main>`
// padding + fade-up entrance animation. Kept as a named component (rather
// than removed) so every existing page can still `import Layout from ...`
// without a 47-file rename — the change is fully transparent.
export default function Layout({ children, mainProps = {} }) {
  return (
    <main className="flex-1 px-4 sm:px-6 lg:px-8 py-6 fade-up min-w-0" {...mainProps}>
      {children}
    </main>
  );
}
